import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { State } from 'vuex-class'

import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue'
import AppSearchBtn from '@/components/AppSearchBtn.vue'
import AppSimpleTextField from '@/components/AppSimpleTextField.vue'
import { showErrors, showNotification } from '@/utils/snack'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { utcDateTimeToLocal } from '@/utils/dateTime'
import ListPage from '@/mixins/list-page'
import { exportProfitSharingsList, findProfitSharings } from './gql'
import { ProfitSharingModel, ProfitSharingsFindOrdersBy } from '@/interfaces/profitSharing'
import { ProfitSharingStatusText } from '@/helpers/profitSharing'
import { TypedGqlError } from '@/interfaces/error'
import { formatCurrency } from '@/utils/currency'
import { SnackType } from '@/interfaces/snack'
import { downloadBase64 } from '@/helpers/base64-to-file'

@Component({
  components: {
    AppBreadcrumbs,
    AppRefreshAndExport,
    AppSimpleTextField,
    AppSearchBtn,
    AppTextField
  }
})
export default class ProfitSharingsList extends mixins(ListPage) {
  @State(state => state.page.OrderList) cache!: string
  breadcrumbs: Breadcrumb[] = [
    {
      text: '订单管理管理'
    }, {
      text: '佣金管理'
    }
  ]

  options = {
    sortBy: ['createdAt'],
    page: 1,
    itemsPerPage: 10,
    sortDesc: [true]
  }

  utcDateTimeToLocal = utcDateTimeToLocal
  formatCurrency = formatCurrency
  ProfitSharingStatusText = ProfitSharingStatusText
  filter = {
    profitSharingNumber: null,
    orderNumber_OF_order: null
  }

  totalNum = 0
  loading = false

  usingStatus (status: string) {
    return {
      'u-tag-blue': status === 'TO_BE_SHARING',
      'u-tag-red': status === 'CHANGE',
      'u-tag-orange': status === 'PROCESSING',
      'u-tag-green': status === 'SUCCESS'
    }
  }

  headers = [
    { text: '佣金编号', value: 'profitSharingNumber', width: 120, sortable: false },
    { text: '佣金创建时间', value: 'createdAt' },
    { text: '佣金成功时间', value: 'timeEnd', sortable: false },
    { text: '佣金状态', value: 'status', width: 120, sortable: false },
    { text: '佣金金额', value: 'totalPrice' },
    { text: '订单号', value: 'orderNumber', sortable: false },
    { text: '订单金额', value: 'orderPrice', sortable: false },
    { text: '订单时间', value: 'orderCreatedAt', sortable: false },
    { text: '经销商姓名', value: 'dealerName', sortable: false },
    { text: '经销商电话', value: 'dealerPhone', sortable: false }
  ]

  windowSize = {
    w: 0,
    h: 0
  }

  actionsHeight = 51
  profitSharings: ProfitSharingModel[] = []

  @Watch('options', { deep: true })
  onOptionsChanged () {
    this.getProfitSharings()
  }

  mounted () {
    this.onResize()
    this.restorePage(this.cache)
    this.getProfitSharings()
  }

  // 获取佣金列表
  async getProfitSharings () {
    const { sortBy, page, itemsPerPage, sortDesc } = this.options
    const { profitSharingNumber, orderNumber_OF_order } = this.filter
    const by = ProfitSharingsFindOrdersBy[sortBy[0] || 'createdAt']
    const asc = !sortDesc[0] || false

    this.loading = true
    const order = { by, asc }
    const paging = {
      skip: itemsPerPage * (page - 1),
      take: itemsPerPage
    }
    const where = {
      orderNumber_OF_order: orderNumber_OF_order || null,
      profitSharingNumber
    }
    const result = await this.queryProfitSharings(order, paging, where)

    if (result) {
      this.profitSharings = result.profitSharings
      this.totalNum = result.paging.totalCount
    }
    this.loading = false
    this.storePage()
  }

  async queryProfitSharings (order: any, paging: any, where: any) {
    try {
      const result = await this.$apollo.query({
        query: findProfitSharings,
        variables: {
          order,
          paging,
          where
        }

      })
      return result.data.findProfitSharings
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  filterQuerySubmit () {
    this.getProfitSharings()
  }

  refreshList () {
    this.filter = {
      profitSharingNumber: null,
      orderNumber_OF_order: null
    }
    this.getProfitSharings()
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
    const actionDom = this.$refs.actions as Vue & {
      clientHeight: number;
    }
    this.actionsHeight = actionDom.clientHeight
  }

  async exportHandler () {
    showNotification({
      msg: '即将开始下载...',
      type: SnackType.Info
    })
    const { sortBy, sortDesc } = this.options
    const {
      orderNumber_OF_order,
      profitSharingNumber
    } = this.filter
    const by = ProfitSharingsFindOrdersBy[sortBy[0] || 'createdAt']
    const asc = !sortDesc[0] || false
    this.loading = true
    const order = { by, asc }
    const where = {
      orderNumber_OF_order: orderNumber_OF_order || null,
      profitSharingNumber: profitSharingNumber || null
    }
    try {
      const result = await this.$apollo.query({
        query: exportProfitSharingsList,
        variables: {
          order,
          where
        }
      })
      if (result.data) {
        const { fileName, contentB64 } = result.data.exportProfitSharingsList
        downloadBase64(contentB64, fileName)
      }
      this.loading = false
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }
}
